module.exports = __webpack_public_path__ + "img/icon27.b1bd8628.svg";